// @flow

import { type CardBrand } from './types';

type CardBrandPattern = {|
  brand: CardBrand,
  pattern: RegExp,
|};

const patterns: ImmutableArray<CardBrandPattern> = [
  { brand: 'visa', pattern: /^4/ },
  { brand: 'mastercard', pattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/ },
  { brand: 'carnet', pattern: /^(286900|502275|506(199|2(0[1-6]|1[2-578]|2[289]|3[67]|4[579]|5[0-57-9]|6[1-79]|7[02-9]|8[0-8]|9[234679])|3(0[0-9]|1[1-479]|2[0239]|3[02-79]|4[0-49]|5[0-79]|6[014-79]|7[0-49]|8[0-467]|9[124])|402)|588772(2|02|66|67|68|74|84)|6046220[34]|604622(69|3|4)|606333|63(6379|9(388|484|559)))/ },
  { brand: 'amex', pattern: /^3[47]/ },
  { brand: 'troy', pattern: /^(9792|36577[0-3]|6500(52|8[23]|92)|650161|65017[035]|6502(68|7[134])|65045[67]|6508(3[67]|4[6-9]|50|5[89]|6[0-27-9])|650923|6509(87|90)|654997|657366|657998|6587(5[0-25689]|6[0-25-8]|7[12678]|8[2-6]|98)|65880[89]|9000(0[1-9]|[12][0-9]|3[0-13-7]|40)|9001(08|35)|900210)/ },
  { brand: 'diners', pattern: /^(36|38|30[0-5])/ },
  { brand: 'verve', pattern: /^(506099|5061(?:9[0-8]|[0-8]\d)|6500(?:0[2-9]|1\d|2[0-7])|507(?:8(?:6[5-9]|[7-9]\d)|9(?:[0-5]\d|6[0-4])))\d{10,13}/ },
  { brand: 'discover', pattern: /^(65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10}))/ },
  { brand: 'elo', pattern: /^(4011|438935|45(1416|76|7393)|50(4175|6699|67|90[4-7])|63(6297|6368))/ },
  { brand: 'hipercard', pattern: /^(606282\d{10}(\d{3})?)|(3841\d{15})/ },
  { brand: 'naranja', pattern: /^(589562|402917|402918|527571|527572|0377798|0377799)/ },
  { brand: 'meeza', pattern: /^(507803)/ },
  { brand: 'rupay', pattern: /^(652331)/ },
];

export function detectCardBrand(value: string): ?CardBrand {
  const pattern = patterns.find(item => item.pattern.test(value));
  if (pattern) {
    return pattern.brand;
  }
  return null;
}
